import React, {useMemo, useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {P11CompetitionItem, P11MatchItem} from '../../home.service';
import {HomeGameFloorItem} from '../../home.type';
import {openPick11} from '../../pick11-navigate';
import {Pick11NewCard} from '../pick11/new-card';
import globalStore from '@/services/global.state';
import {Image} from 'antd-mobile';
import {ReactComponent as RightPointedArrowIcon} from '@components/assets/icons/right-pointed-arrow.svg';

/** pick11 楼层的数据来源是 api/front/p11/match/list-display，不依赖楼层接口的 gamesList */
export default function HomePick11({
  data,
  p11Data,
}: {
  data: HomeGameFloorItem;
  p11Data?: P11CompetitionItem[] | null;
}) {
  const {t} = useTranslation();

  const handleAllClick = useCallback(() => {
    openPick11();
  }, []);

  const handleMatchClick = useCallback((match: P11MatchItem) => {
    const matchId = match.fantasyMatchId ?? match.id;
    if (matchId != null) {
      openPick11(matchId);
    }
  }, []);

  const list = useMemo(() => p11Data ?? [], [p11Data]);
  const matches = useMemo(() => {
    const items: P11MatchItem[] = [];
    list
      .filter(c => c.matches && c.matches.length > 0)
      .forEach(c => items.push(...(c.matches ?? [])));
    return items;
  }, [list]);

  const hasCompetitions = list.some(c => c.matches && c.matches.length > 0);
  if (!hasCompetitions || matches.length === 0) {
    return null;
  }

  // Pick11Card 是 Web 组件，只在 Web 环境下渲染
  if (!globalStore.isWeb) {
    return null;
  }

  const renderIcon = data.categoryPic ? (
    <Image width={'1.75rem'} height={'1.75rem'} src={data.categoryPic} />
  ) : null;

  return (
    <div className="flex flex-col gap-2 w-full mb-3">
      {/* 头部 */}
      <div className="flex flex-row justify-between items-center px-2">
        <div className="flex flex-row items-center gap-2">
          {renderIcon}
          <span className="text-t1 text-base font-bold capitalize">
            {data.name}
          </span>
        </div>
        <div
          className="flex flex-row items-center gap-1 cursor-pointer"
          onClick={handleAllClick}>
          <div className="flex items-center gap-[2px]">
            {/* <span className="text-[#D90000] text-xs font-bold">{allLen}</span> */}
            <span className="text-t3 text-[0.875rem]">
              {t('home.label.all')}
            </span>
          </div>
          <RightPointedArrowIcon />
        </div>
      </div>

      {/* 卡片列表 - 竖直排列 */}
      <div className="flex flex-col gap-2 px-2">
        {matches.map((match, index) => (
          <Pick11NewCard
            key={match.id ?? match.fantasyMatchId ?? index}
            match={match}
            onClick={() => handleMatchClick(match)}
          />
        ))}
      </div>
    </div>
  );
}
